export default __webpack_public_path__ + "static/flop-ad-1f404fd083b5c215528524a8b612d0c4.png";